import React from 'react'
import { AccountLinkModel } from '../models'

interface ContextProps {
  accountLinks: AccountLinkModel[]
  isLoadingAccountLinks: boolean
  updateAccountLinks?: () => void
}

export const AccountLinksContext = React.createContext<ContextProps>({ accountLinks: [], isLoadingAccountLinks: true })

export const useAccountLinkContext = (): ContextProps => {
  const context = React.useContext(AccountLinksContext)
  if (!context) {
    throw new Error('useAccountLinkContext must be used within an AccountLinksProvider')
  }
  return context
}
